/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import { Button, Modal, Popover } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { plusicon } from '../../components/imagepath';
import { ActionDeleteById } from '../../store/Actions/CommonAction';
import { matchPermissions } from '../../utils/Permission';
import AdvancedTable from '../../components/AdvancedTable';
import { GetPaginatedPermissionApi } from '../../utils/api';
import { useCallback } from 'react';
import { PERMISSIONS } from '../../constants';
const { confirm } = Modal;
const Permissions = () => {
  const [EditMembersModal, SetEditMembersModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state?.auth);

  const handleRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.PERMISSIONS_MANAGEMENT.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.PERMISSIONS_MANAGEMENT.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.PERMISSIONS_MANAGEMENT.DELETE);
  const canCreate = matchPermissionsForUser(PERMISSIONS.PERMISSIONS_MANAGEMENT.CREATE);
  const content = item => (
    <div className="row col">
      {canUpdate && (
        <Button
          className="col m-2"
          onClick={() => {
            window.location.href = `permissions/create-permissions?update=true&&page=${1}&&id=${item?.id}`;
          }}
        >
          Edit Permission
        </Button>
      )}
      {canDelete && (
        <Button className="col m-2" onClick={() => showDeleteConfirm(item)}>
          Delete Permission
        </Button>
      )}
    </div>
  );

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.moduleName} Permission?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteById({ Query: `admin/permissions/${item?.id}` }, Res => {
            if (Res?.statusCode === 200) {
              handleRefresh();
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };
  const columns = [
    {
      id: 'sr',
      name: 'Sr',
      cell: (record, index) => {
        const currentPage = parseInt(page) || 1;
        const calculatedIndex = (currentPage - 1) * perPage + index + 1;
        return <span>{calculatedIndex}</span>;
      },
      width: 80,
    },
    {
      id: 'moduleName',
      name: 'Module Name',
      selector: row => row.moduleName,
      sortable: true,
    },
    {
      id: 'name',
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      id: 'actions',
      name: 'Action',
      cell: record => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover placement="top" title={record.moduleName} content={() => content(record)}>
              <Button type="text">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];

  const fetchData = useCallback(
    async ({ page, perPage, search, sortField, sortOrder }) => {
      setPage(page);
      setPerPage(perPage);
      const query = `?page=${page}&limit=${perPage}${search ? `&search=${search}` : ''}${sortField ? `&sortField=${sortField}&sortOrder=${sortOrder}` : ''
        }`;
      const response = await GetPaginatedPermissionApi({ Query: query });
      if (response?.status === 200) {
        return {
          data: response.data?.data?.[0]?.docs || [],
          total: response.data?.data?.[0]?.totalDocs || 0,
        };
      }
      return { data: [], total: 0 };
    },
    [refreshKey]
  );
  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link>Permissions</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Permissions List</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Permissions List</h3>
                              <div className="add-group">                                {canCreate && (
                                <Link
                                  to={`/permissions/create-permissions`}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img src={plusicon} alt="#" />
                                </Link>
                              )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        {canView ? (
                          <AdvancedTable
                            resource="permissions"
                            columns={columns}
                            fetchData={fetchData}
                            enableSearch={true}
                            enableRefresh={true}
                            enableColumnManager={true}
                            enableExport={true}
                            striped={true}
                            highlightOnHover={true}
                          />
                        ) : (
                          <div className="permission-denied-message">
                            You do not have permission to view permissions management.
                          </div>
                        )}

                        <Modal
                          open={EditMembersModal}
                          closable={true}
                          className="ant-modal"
                          forceRender={true}
                          zIndex={900}
                          style={{ margin: 10 }}
                          onOk={() => SetEditMembersModal(false)}
                          styles={{
                            body: {
                              overflow: 'hidden',
                            },
                            mask: {
                              backdropFilter: 'blur(10px)',
                            },
                            content: {
                              borderRadius: 40,
                            },
                          }}
                          okText={'Submit'}
                          centered
                          confirmLoading={false}
                          onCancel={() => SetEditMembersModal(false)}
                          closeIcon={true}
                        ></Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Permissions;
